import { render, staticRenderFns } from "./CriterioSelectSegments.vue?vue&type=template&id=37bb29be"
import script from "./CriterioSelectSegments.vue?vue&type=script&lang=js"
export * from "./CriterioSelectSegments.vue?vue&type=script&lang=js"
import style0 from "./CriterioSelectSegments.vue?vue&type=style&index=0&id=37bb29be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports